import { TranslateService } from '@ngx-translate/core';
import { getOptionalI18nKey } from '@core/shared/i18n';
import * as i0 from "@angular/core";
export let I18nService = /*#__PURE__*/(() => {
  class I18nService extends TranslateService {
    // overridden method of TranslateService, to treat translation data the same way nestjs-i18n does in backend
    getParsedResult(translations, key, interpolateParams) {
      this.currentLang;
      let res;
      // in case of array, we can fall back to the standard implementation which will call this method again for each part of the array.
      if (key instanceof Array) {
        return super.getParsedResult(translations, key, interpolateParams);
      }
      if (translations) {
        res = this.parser.interpolate(this.parser.getValue(translations, key), interpolateParams, this.currentLang);
      }
      if (typeof res === "undefined" && this.defaultLang != null && this.defaultLang !== this.currentLang && this.useDefaultLang) {
        res = this.parser.interpolate(this.parser.getValue(this.translations[this.defaultLang], key), interpolateParams, this.defaultLang);
      }
      if (typeof res === "undefined") {
        const params = {
          key,
          translateService: this
        };
        if (typeof interpolateParams !== 'undefined') {
          params.interpolateParams = interpolateParams;
        }
        res = this.missingTranslationHandler.handle(params);
      }
      return typeof res !== "undefined" ? res : key;
    }
    // for use with strings that may have been wrapped using global i18n function. See I18N.MD for details.
    maybeTranslate(stringValue, defaultValue) {
      const info = getOptionalI18nKey(stringValue);
      // console.log('maybeTranslate',info, stripI18nIdentifier(stringValue),this.translations, this.instant(stripI18nIdentifier(stringValue)));
      if (info) return this.translate(info.key, info.params);else if (defaultValue) return defaultValue;else return stringValue;
    }
    /**
     * method aliases for consistency with backend / nestjs i18n service
     */
    translate$(key, params = {}) {
      return this.get(key, params);
    }
    translate(key, params = {}) {
      return this.instant(key, params);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵI18nService_BaseFactory;
        return function I18nService_Factory(__ngFactoryType__) {
          return (ɵI18nService_BaseFactory || (ɵI18nService_BaseFactory = i0.ɵɵgetInheritedFactory(I18nService)))(__ngFactoryType__ || I18nService);
        };
      })();
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: I18nService,
        factory: I18nService.ɵfac
      });
    }
  }
  return I18nService;
})();